/* MSE Stats (C3): Zahlen zaehlen in ca. 1,5 s von 0 hoch, jedes Mal wenn der
   Banner wieder ins Bild kommt. Endwerte stehen im HTML. Bei reduzierter
   Bewegung oder ohne IntersectionObserver passiert nichts. */
(function () {
  if (window.mseStatsInit) return;
  window.mseStatsInit = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var DAUER = 1500;

  function zaehlen(el) {
    var ziel = parseInt(el.getAttribute('data-to'), 10);
    if (!ziel) return;
    var start = null;
    if (el._mseRaf) cancelAnimationFrame(el._mseRaf);
    function schritt(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / DAUER);
      el.textContent = Math.round(ziel * (1 - Math.pow(1 - p, 3)));
      if (p < 1) el._mseRaf = requestAnimationFrame(schritt);
    }
    el._mseRaf = requestAnimationFrame(schritt);
  }

  function init() {
    document.querySelectorAll('[data-mse-stats]').forEach(function (sec) {
      if (sec._mseStats) return;
      sec._mseStats = true;
      var zahlen = sec.querySelectorAll('.mse-stats__number[data-to]');
      if (!zahlen.length) return;
      var sichtbar = false;
      new IntersectionObserver(
        function (eintraege) {
          eintraege.forEach(function (e) {
            if (e.isIntersecting && !sichtbar) {
              sichtbar = true;
              zahlen.forEach(zaehlen);
            } else if (!e.isIntersecting) {
              sichtbar = false;
            }
          });
        },
        { threshold: 0.35 }
      ).observe(sec);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
